import WeatherIcon from './weather-icon'
export default WeatherIcon
